module.exports = __webpack_public_path__ + "img/login-foreground.7b86c008.png";